import React from "react";

interface EmptyStateProps {
  text: string;
  subText: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  text,
  subText,
  className,
}) => {
  return (
    <div
      className={
        className
          ? className
          : `flex flex-col items-center justify-center space-y-[12px] min-h-[calc(100vh-250px)]`
      }
    >
      <p className="text-text-base text-[14px] font-medium text-center">{text}</p>
      <p className="text-text-subtle text-[12px] font-normal text-center">
        {subText}
      </p>
    </div>
  );
};

export default EmptyState;
